import styled from "styled-components";

export const InfoBoxesRow = styled.div`
  width: 100%;
  max-width: 600px;
  display: flex;
  gap: 12px;
`;

export const InfoBox = styled.div`
  flex: 1;
  min-width: 0;
  background: #fff;
  border: 1px solid #e9e9e9;
  box-shadow: 0 3px 10px rgba(17, 24, 39, 0.06);
  border-radius: 16px;
  padding: 16px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  text-align: center;
  white-space: nowrap;
`;

export const BoxLabel = styled.span`
  font-size: 13px;
  color: #8e8e8e;
`;

export const BoxValueSmall = styled.strong`
  display: flex;
  gap: 12px;
  color: #B94049;
`;